import type FolderStore from "./schema/FolderStore";

import { createStore } from "owa-satcheljs";

export const getStore: () => FolderStore = createStore<FolderStore>("folderStore", {
    folderTable: new Map(),
    mailboxFolderTreeData: new Map(),
    foldersInLoadingState: [],
    isAlphabetizeFolderList: false,
});
export default getStore;
